import React from 'react'
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useUtils from '../../../custom-hooks/use-utils-helper'
import {useLocation} from 'react-router-dom'

const AlternateMetaTag = ({links, pid = null}) => {
    const {customParams} = getConfig()
    const location = useLocation()
    const {isCategory, isProductDetail} = useUtils().currentPage(location.pathname)

    return (
        <Helmet>
            {links.map((item, key) => {
                const hreflang = item?.hreflang === 'en' ? 'x-default' : item?.hreflang

                if (isCategory) {
                    const pathnameNoPrefix = item.url.split('/c/')?.[1]
                    if (pathnameNoPrefix) item.url = '/' + item?.hreflang + '/c/' + pathnameNoPrefix
                }

                if (isProductDetail) {
                    const pathnameNoPrefix = item.url.split('/p/')?.[1]
                    if (pathnameNoPrefix) item.url = '/' + item?.hreflang + '/p/' + pathnameNoPrefix
                    if (pid) item.url = item.url.split('?')[0] + '?pid=' + pid
                }

                const url = `https://${customParams.currentHost}${item?.url}`

                return <link key={key} rel="alternate" hrefLang={hreflang} href={url} />
            })}
        </Helmet>
    )
}

AlternateMetaTag.propTypes = {
    links: PropTypes.array,
    pid: PropTypes.string,
}

export default AlternateMetaTag
